export default "__VITE_ASSET__CvcX_oWT__"